export const phone = /^[0-9-()\s]{7,15}$/;
